export default __webpack_public_path__ + "static/media/Referidos-728x90.5ded7d3c.jpg";